// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"8c99262a","213":"6067bfc4","455":"342b95af"}[chunkId] + ".chunk.js";
};